/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvTranDetCompleteModel { 
    guid?: string | null;
    invTranDetId?: number;
    invTranId?: number;
    itemNumber?: string | null;
    uOfM?: string | null;
    units?: number;
    quantity?: number;
    workOrderId?: number;
    uniqueIdentifierType?: number | null;
    uniqueIdentifier?: string | null;
    batchIdentifierType?: number | null;
    batchIdentifier?: string | null;
    sellByDate?: string | null;
    barcodeSource?: string | null;
    reference?: string | null;
    linkCustomerOrderDetId?: number | null;
    statusId?: number;
}

